import { Card, Col, Row, Skeleton } from "antd";

export default function CardSkeleton({ boxes }) {
  return (
    <Row gutter={[16, 16]} justify="start" style={{ marginTop: "16px" }}>
      {Array.from({ length: boxes }).map((_, index) => (
        <Col xs={24} sm={12} md={8} key={index}>
          <Card
            style={{
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Skeleton active avatar paragraph={{ rows: 1 }} />
          </Card>
        </Col>
      ))}
    </Row>
  );
}
